import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import {
  CRow,
  CCol,
  CSpinner,
  CContainer,
  CForm,
  CInputGroup,
  CFormInput,
  CInputGroupText,
  CImage,
  CButton,
} from '@coreui/react'
import ReCAPTCHA from 'react-google-recaptcha'
import { ver, nover } from 'src/assets/icon'
import api from '../../api/api'
import CIcon from '@coreui/icons-react'

const Intranet = () => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const basePath = String(process.env.PUBLIC_URL).trim()
  const [visualizar, setVer] = useState(false)
  const [usuario, setUsuario] = useState('')
  const [pass, setPass] = useState('')
  const [error, setError] = useState('')
  const captcha = useRef(null)

  function handleLogin(e) {
    e.preventDefault()
    setLoading(true)

    if (validando()) {
      setError('')
      api
        .sistemas({
          usuario: usuario,
          contrasenia: pass,
          captcha: captcha.current.getValue(),
        })
        .then((res) => {
          if (res.data) {
            history.push({
              pathname: basePath + '/pf/empleo-publico/intranet',
              state: { usuario: usuario, ...res.data },
            })
          } else {
            setError('Error al comunicarse con la base de datos')
          }
          setLoading(false)
        })
        .catch((e) => {
          captcha.current.reset()
          if (e.response.status === 422) {
            setError('Usuario y/o contraseña incorrecto.')
          } else {
            setError(e.response.data.error)
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      if (validando()) {
        handleLogin(e)
      }
    }
  }

  function validando() {
    if (usuario === '') {
      document.getElementById('usuario').focus()
      setError('Ingrese su usuario.')
      return false
    }
    if (pass === '') {
      document.getElementById('password').focus()
      setError('Ingrese una contraseña.')
      return false
    }
    if (captcha.current.getValue() === '') {
      setError('Debe validar el reCAPTCHA.')
      return false
    }
    return true
  }

  function handleOnClickRecuperarContrasenia() {
    let tam =
      'height=' +
      window.innerHeight * 0.6 +
      ',width=' +
      window.innerWidth * 0.5 +
      ' left=' +
      window.innerWidth * 0.27 +
      ' top=' +
      window.innerHeight * 0.1 +
      ',resizable=yes'
    window.open(
      'https://apps2.entrerios.gov.ar/bdu/recuperar-contrasenia',
      'Recuperar contraseña',
      tam,
    )
  }

  return (
    <div className="mt-300 pt-4 pb-4 fondoBeigeER">
      <CContainer fluid className="container-er">
        <CRow>
          <CCol xs={12}>
            <CRow>
              <CCol xs={12} md={12}>
                <h1>Intranet</h1>
              </CCol>
              <CCol xs={12} md={12}>
                <div className="texto-descripcion-l mb-4">
                  Si tenés usuario y contraseña podés ingresar para realizar todas tus tareas.
                </div>
              </CCol>
              <CCol xs={12}>
                <CForm>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      type="text"
                      id="usuario"
                      value={usuario}
                      onChange={(e) => setUsuario(e.target.value)}
                      onKeyPress={handleKeyPress}
                      placeholder="Ingresa tu DNI"
                      autoComplete="username"
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-4">
                    {visualizar ? (
                      <>
                        <CFormInput
                          type="text"
                          id="password"
                          value={pass}
                          onChange={(e) => setPass(e.target.value)}
                          onKeyPress={handleKeyPress}
                          placeholder="Ingresa tu CONTRASEÑA"
                          autoComplete="current-password"
                        />
                        <CInputGroupText id="icon-nover" className="imagen-input">
                          <CIcon icon={nover} onClick={() => setVer(false)} />
                        </CInputGroupText>
                      </>
                    ) : (
                      <>
                        <CFormInput
                          type="password"
                          id="password"
                          value={pass}
                          onChange={(e) => setPass(e.target.value)}
                          onKeyPress={handleKeyPress}
                          placeholder="Ingresa tu CONTRASEÑA"
                          autoComplete="current-password"
                        />
                        <CInputGroupText id="icon-ver" className="imagen-input">
                          <CIcon icon={ver} onClick={() => setVer(true)} />
                        </CInputGroupText>
                      </>
                    )}
                  </CInputGroup>
                  <CRow className="justify-content-center mb-4 text-center">
                    <div className="recaptcha">
                      <ReCAPTCHA ref={captcha} sitekey="6LdsgSgbAAAAAPg_cxA1KmgM43Lx7Mwas19i6y2A" />
                    </div>
                  </CRow>
                  <CRow className="justify-content-center text-center">
                    <CCol>{error !== '' && <div className="alert alert-danger">{error}</div>}</CCol>
                  </CRow>
                  <CRow>
                    <CCol lg="12" className="text-center">
                      {loading ? (
                        <CButton color="primary" className="btn-block w-100" size="lg" disabled>
                          <CSpinner size="sm" />
                        </CButton>
                      ) : (
                        <CButton
                          color="primary"
                          className="btn-block w-100"
                          size="lg"
                          onClick={handleLogin}
                        >
                          INGRESAR
                        </CButton>
                      )}
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol lg="12" className="text-center">
                      <p className="btn btn-link" onClick={handleOnClickRecuperarContrasenia}>
                        ¿Ha olvidado su contraseña?
                      </p>
                    </CCol>
                  </CRow>
                </CForm>
              </CCol>
            </CRow>
          </CCol>
          {/* <CCol className="d-none d-sm-none d-md-flex" md={6} lg={6} xl={6}>
            <CImage
              src="https://portal.entrerios.gov.ar/media/img/intranet.png"
              alt="Imagen login."
              style={{ objectFit: 'cover' }}
              width="100%"
              height="100%"
            ></CImage>
          </CCol> */}
        </CRow>
      </CContainer>
    </div>
  )
}

export default React.memo(Intranet)
